import { RenterDto } from '@tallo/renter';

import { RescheduleRequestStatus } from '../interfaces/reschedule-request.interface';
import { ShowingRequestStatus } from '../interfaces/showing-request-status.enum';
import { ShowingDto } from '../interfaces/showing.interface';

export function getExpiredRenters(showing: ShowingDto): RenterDto[] {
  return [
    ...showing.showingRequests
      .filter(({ status }) => status === ShowingRequestStatus.EXPIRED)
      .map(({ renter }) => renter),

    ...showing.rescheduleRequests
      .filter(({ status }) => [RescheduleRequestStatus.EXPIRED].includes(status))
      .map(({ renter }) => renter),
  ];
}
